import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../store/store.ts';
import { DoraContractualArrangementDetail } from '../../models/doraContractualArrangementDetail.ts';

interface ArrangementDetailState {
  details: DoraContractualArrangementDetail[];
  loading: boolean;
  error: string | null;
}

const initialState: ArrangementDetailState = {
  details: [],
  loading: false,
  error: null,
};

const contractualArrangementDetailSlice = createSlice({
  name: 'doraContractualArrangementDetail',
  initialState,
  reducers: {
    setArrangementDetails(state, action: PayloadAction<DoraContractualArrangementDetail[]>) {
      state.details = action.payload;
    },
    addArrangementDetail(state, action: PayloadAction<DoraContractualArrangementDetail>) {
      state.details.push(action.payload);
    },
    updateArrangementDetail(state, action: PayloadAction<DoraContractualArrangementDetail>) {
      const idx = state.details.findIndex(d => d.id === action.payload.id);
      if (idx !== -1) state.details[idx] = action.payload;
    },
    removeArrangementDetail(state, action: PayloadAction<number>) {
      state.details = state.details.filter(d => d.id !== action.payload);
    },
    setArrangementDetailLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setArrangementDetailError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const {
  setArrangementDetails,
  addArrangementDetail,
  updateArrangementDetail,
  removeArrangementDetail,
  setArrangementDetailLoading,
  setArrangementDetailError,
} = contractualArrangementDetailSlice.actions;

export const selectArrangementDetails = (state: RootState) => state.doraContractualArrangementDetail.details;
export const selectArrangementDetailLoading = (state: RootState) => state.doraContractualArrangementDetail.loading;
export const selectArrangementDetailError = (state: RootState) => state.doraContractualArrangementDetail.error;

export default contractualArrangementDetailSlice.reducer;
